<template>
  <v-app class="tenant-app">
    <v-app-bar
      app
      flat
      color="white"
      light
      height="70"
      class="main-header border-bottom-light"
    >
      <div class="d-flex align-center w-100 px-2">
        <v-btn icon class="back-btn mr-2" aria-label="Kembali" @click="goBack">
          <v-icon color="#1e293b">mdi-arrow-left</v-icon>
        </v-btn>

        <v-avatar color="rgba(1, 140, 116, 0.1)" size="40" class="mr-3 rounded-lg">
          <v-icon color="#018c74" size="24">mdi-store-outline</v-icon>
        </v-avatar>
        <div>
          <h1
            class="text-subtitle-1 font-weight-bold primary-text mb-0"
            style="line-height: 1.2"
          >
            DAFTAR TENANT
          </h1>
          <p class="text-caption text-secondary mb-0">
            Sub Kategori:
            <span class="font-weight-bold" style="color: #cfa22d">{{ subName }}</span>
          </p>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-content-layout">
      <v-container fluid class="pa-4 fill-height-container">
        <v-row class="fill-height-row" no-gutters>
          <v-col cols="12" md="4" lg="3" class="pr-md-3 fill-column">
            <v-card class="sidebar-layout-card d-flex flex-column" flat rounded="lg">
              <div class="sidebar-top-pane pa-4 pb-2">
                <h2 class="text-subtitle-2 font-weight-bold mb-3 primary-text">
                  Daftar Tenant
                </h2>
                <v-text-field
                  v-model="searchQuery"
                  placeholder="Cari tenant..."
                  outlined
                  dense
                  hide-details
                  clearable
                  color="#018c74"
                  class="search-field"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="grey lighten-1" size="20" class="mr-1"
                      >mdi-magnify</v-icon
                    >
                  </template>
                </v-text-field>
              </div>

              <div class="sidebar-scroll-content flex-grow-1 overflow-y-auto px-4 py-2">
                <div
                  v-if="filteredTenants.length === 0"
                  class="text-center py-8 text-caption text-secondary"
                >
                  <v-icon color="grey lighten-1" size="32" class="mb-2"
                    >mdi-store-off-outline</v-icon
                  >
                  <div>Tidak ada tenant untuk "{{ searchQuery }}"</div>
                </div>

                <v-card
                  v-for="tenant in filteredTenants"
                  :key="tenant.id"
                  :class="[
                    'tenant-item-card mb-3',
                    { 'active-item': activeTenantId === tenant.id },
                  ]"
                  outlined
                  flat
                  rounded="lg"
                  @click="selectTenant(tenant)"
                >
                  <v-row no-gutters class="pa-2 flex-nowrap" align="center">
                    <v-col cols="3" class="flex-grow-0 flex-shrink-0">
                      <v-avatar size="45" class="rounded-lg border-primary bg-light" tile>
                        <v-icon
                          v-if="isVideo(getFirstMedia(tenant))"
                          size="20"
                          color="#CFA22D"
                        >
                          mdi-video
                        </v-icon>
                        <v-img v-else :src="getThumbnail(tenant)" cover />
                      </v-avatar>
                    </v-col>

                    <v-col
                      class="pl-3 py-1 d-flex flex-column justify-center overflow-hidden"
                    >
                      <div
                        class="text-overline font-weight-bold"
                        style="
                          color: #cfa22d;
                          font-size: 0.6rem !important;
                          line-height: 1;
                        "
                      >
                        ID-{{ String(tenant.id).padStart(3, "0") }}
                      </div>
                      <h3
                        class="text-caption font-weight-bold primary-text text-truncate mb-0 mt-1"
                      >
                        {{ tenant.nama_profil.toUpperCase() }}
                      </h3>
                    </v-col>

                    <v-col cols="auto" class="pl-2 flex-grow-0 flex-shrink-0">
                      <v-btn
                        icon
                        small
                        color="#018c74"
                        class="action-route-btn"
                        @click.stop="goToDetail(tenant.id)"
                      >
                        <v-icon small>mdi-arrow-right-circle</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <div class="row-hover-effect"></div>
                </v-card>
              </div>

              <div class="sidebar-bottom-pane pa-4 pt-2">
                <!-- Tombol Kontribusi Publik (animated) -->
                <v-btn
                  block
                  depressed
                  color="#018c74"
                  class="btn-kontribusi white--text text-capitalize font-weight-bold rounded-lg mb-2"
                  @click="dialogTambah = true"
                >
                  <v-icon left small class="kontribusi-icon"
                    >mdi-plus-circle-outline</v-icon
                  >
                  Kontribusi Publik
                </v-btn>
                <v-btn
                  block
                  depressed
                  disabled
                  color="#f8fafc"
                  class="text-capitalize font-weight-bold rounded-lg primary-text"
                  style="
                    background-color: #f8fafc !important;
                    color: #1e293b !important;
                    opacity: 1;
                  "
                >
                  <v-icon left small color="#018c74">mdi-layers-triple-outline</v-icon>
                  {{ filteredTenants.length }} Data
                </v-btn>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="8" lg="9" class="pl-md-1 fill-column d-flex flex-column">
            <v-card class="map-container-card flex-grow-1 mb-3" flat rounded="lg">
              <div id="map" class="map-inner-display"></div>
            </v-card>

            <v-card
              v-if="selectedTenantData"
              class="detail-display-card pa-4"
              flat
              rounded="lg"
            >
              <v-row no-gutters>
                <v-col
                  cols="12"
                  sm="4"
                  md="3"
                  class="pr-sm-4 mb-3 mb-sm-0 d-flex align-stretch"
                >
                  <div
                    class="media-detail-wrapper w-100 rounded-lg overflow-hidden border"
                  >
                    <video
                      v-if="isVideo(getFirstMedia(selectedTenantData))"
                      :src="getThumbnail(selectedTenantData)"
                      controls
                      playsinline
                      class="detail-preview-video"
                    ></video>

                    <v-img
                      v-else
                      :src="getThumbnail(selectedTenantData)"
                      class="detail-preview-img"
                      height="100%"
                      max-height="150"
                      cover
                    ></v-img>
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  sm="8"
                  md="9"
                  class="d-flex flex-column justify-space-between"
                >
                  <div>
                    <div class="d-flex align-center justify-space-between flex-wrap">
                      <h2 class="text-h6 font-weight-bold primary-text mb-0">
                        {{ selectedTenantData.nama_profil.toUpperCase() }}
                      </h2>
                      <div class="mt-2 mt-sm-0">
                        <v-btn
                          small
                          outlined
                          color="#018c74"
                          class="text-capitalize rounded-lg mr-2"
                          @click="callTenant(selectedTenantData.kontak)"
                        >
                          <v-icon left small>mdi-phone</v-icon> Hubungi
                        </v-btn>
                        <v-btn
                          small
                          depressed
                          color="#018c74"
                          class="white--text text-capitalize rounded-lg"
                          @click="goToDetail(selectedTenantData.id)"
                        >
                          Lihat Detail <v-icon right small>mdi-chevron-right</v-icon>
                        </v-btn>
                      </div>
                    </div>

                    <div class="d-flex align-center mb-2 mt-1">
                      <v-icon small color="#018c74" class="mr-1">mdi-map-marker</v-icon>
                      <span class="text-caption text-secondary font-weight-medium">
                        {{ selectedTenantData.alamat_lengkap }}
                      </span>
                    </div>
                    <p class="text-caption text-secondary mb-3 info-paragraph-text">
                      {{ selectedTenantData.nama_profil }} merupakan layanan/instansi
                      resmi yang terdaftar di bawah sub kategori {{ subName }} Kabupaten
                      Bondowoso.
                    </p>
                  </div>

                  <div class="specs-horizontal-grid pt-2 border-top-light">
                    <v-row no-gutters class="text-left">
                      <v-col cols="6" sm="3" class="d-flex align-center py-1">
                        <v-icon color="#018c74" size="20" class="mr-2"
                          >mdi-check-circle-outline</v-icon
                        >
                        <div>
                          <div
                            class="text-caption font-weight-bold primary-text mb-0"
                            style="line-height: 1.2"
                          >
                            Terverifikasi
                          </div>
                          <div
                            class="text-overline text-light-grey mb-0"
                            style="
                              font-size: 0.55rem !important;
                              transform: none;
                              letter-spacing: 0;
                              line-height: 1;
                            "
                          >
                            Status Data
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="3" class="d-flex align-center py-1">
                        <v-icon color="#018c74" size="20" class="mr-2"
                          >mdi-clock-outline</v-icon
                        >
                        <div>
                          <div
                            class="text-caption font-weight-bold primary-text mb-0"
                            style="line-height: 1.2"
                          >
                            Jam Kerja
                          </div>
                          <div
                            class="text-overline text-light-grey mb-0"
                            style="
                              font-size: 0.55rem !important;
                              transform: none;
                              letter-spacing: 0;
                              line-height: 1;
                            "
                          >
                            Operasional
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="3" class="d-flex align-center py-1">
                        <v-icon color="#018c74" size="20" class="mr-2"
                          >mdi-card-account-details-outline</v-icon
                        >
                        <div>
                          <div
                            class="text-caption font-weight-bold primary-text mb-0"
                            style="line-height: 1.2"
                          >
                            Lengkap
                          </div>
                          <div
                            class="text-overline text-light-grey mb-0"
                            style="
                              font-size: 0.55rem !important;
                              transform: none;
                              letter-spacing: 0;
                              line-height: 1;
                            "
                          >
                            Persyaratan
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="3" class="d-flex align-center py-1">
                        <v-icon color="#CFA22D" size="20" class="mr-2"
                          >mdi-face-agent</v-icon
                        >
                        <div>
                          <div
                            class="text-caption font-weight-bold primary-text mb-0"
                            style="line-height: 1.2"
                          >
                            Prima
                          </div>
                          <div
                            class="text-overline text-light-grey mb-0"
                            style="
                              font-size: 0.55rem !important;
                              transform: none;
                              letter-spacing: 0;
                              line-height: 1;
                            "
                          >
                            Pelayanan
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <tenant-tambah-dialog
      v-model="dialogTambah"
      :sub-categories="allSubCategories"
      :default-sub-id="$route.params.sub_id"
    />
  </v-app>
</template>

<script>
import axios from "axios";
import { getTenants, getSubCategories } from "@/api/androidInitApi";
import TenantTambahDialog from "@/components/TenantTambahDialog.vue";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

export default {
  components: { TenantTambahDialog },
  data: () => ({
    dialogTambah: false,
    allSubCategories: [],
    tenants: [],
    subName: "Loading...",
    searchQuery: "",
    map: null,
    markerClusterGroup: null,
    activeTenantId: null,
    selectedTenantData: null,
  }),
  computed: {
    filteredTenants() {
      return this.tenants.filter((t) => {
        const matchCategory = t.sub_category_id == this.$route.params.sub_id;
        const matchSearch = t.nama_profil
          .toLowerCase()
          .includes((this.searchQuery || "").toLowerCase());
        return matchCategory && matchSearch;
      });
    },
    totalTenantsInSub() {
      return this.tenants.filter((t) => t.sub_category_id == this.$route.params.sub_id)
        .length;
    },
  },
  async mounted() {
    await this.fetchData();
  },
  beforeDestroy() {
    if (this.map) this.map.remove();
  },
  methods: {
    goBack() {
      // Kembali ke halaman sebelumnya; jika tidak ada riwayat
      // (mis. halaman dibuka langsung via link), arahkan ke beranda.
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push("/");
      }
    },
    isVideo(filename) {
      return /\.(mp4|webm|mov|avi)$/i.test(filename);
    },
    getFirstMedia(tenant) {
      if (!tenant) return null;

      let targetStr = tenant.full_url || tenant.foto || "";
      if (!targetStr) return null;

      try {
        if (targetStr.includes("[") && targetStr.includes("]")) {
          const jsonStartIndex = targetStr.indexOf("[");
          const jsonEndIndex = targetStr.lastIndexOf("]") + 1;
          const jsonString = targetStr.substring(jsonStartIndex, jsonEndIndex);

          const parsedArray = JSON.parse(jsonString);
          if (Array.isArray(parsedArray) && parsedArray.length > 0) {
            return parsedArray[0];
          }
        }

        if (typeof targetStr === "string" && targetStr.trim().startsWith("[")) {
          const parsed = JSON.parse(targetStr);
          if (Array.isArray(parsed) && parsed.length > 0) return parsed[0];
        }
      } catch (e) {
        console.error("Gagal parse media array", e);
      }

      if (targetStr.includes("/")) {
        return targetStr.split("/").pop();
      }

      return targetStr;
    },
    getThumbnail(tenant) {
      if (!tenant) return "/images/default.png";

      const baseUrl = "https://berkah.bondowosokab.go.id:5500/uploads/";
      const firstFile = this.getFirstMedia(tenant);

      if (!firstFile) return "/images/default.png";

      if (firstFile.startsWith("http://") || firstFile.startsWith("https://")) {
        return firstFile;
      }

      return `${baseUrl}${firstFile}`;
    },
    async fetchData() {
      try {
        const [tenants, subCategories] = await Promise.all([
          getTenants(),
          getSubCategories(),
        ]);

        this.tenants = tenants || [];
        this.allSubCategories = subCategories || [];

        const sub = (subCategories || []).find((s) => s.id == this.$route.params.sub_id);

        if (sub) {
          this.subName = sub.nama_sub;
        }

        if (this.filteredTenants.length > 0) {
          this.activeTenantId = this.filteredTenants[0].id;
          this.selectedTenantData = this.filteredTenants[0];
        }

        this.$nextTick(() => this.initMap());
      } catch (e) {
        console.error("API Error", e);
      }
    },
    initMap() {
      if (this.map) {
        this.map.off();
        this.map.remove();
        this.map = null;
      }

      this.map = L.map("map", {
        zoomControl: true,
        attributionControl: false,
        tap: false,
        preferCanvas: true,
      }).setView([-7.9135, 113.8217], 11);

      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors",
      }).addTo(this.map);

      this.markerClusterGroup = L.markerClusterGroup({
        showCoverageOnHover: false,
        zoomToBoundsOnClick: true,
        disableClusteringAtZoom: 16,
      });

      const customIcon = L.divIcon({
        className: "clean-pin-marker",
        html: `<div class="marker-pin-green"><i class="v-icon mdi mdi-map-marker" style="color:#018c74; font-size: 24px;"></i></div>`,
        iconSize: [30, 30],
        iconAnchor: [15, 30],
        popupAnchor: [0, -30],
      });

      const bounds = [];

      this.filteredTenants.forEach((tenant) => {
        if (tenant.lokasi_map && tenant.lokasi_map.includes(",")) {
          const coords = tenant.lokasi_map
            .split(",")
            .map((num) => parseFloat(num.trim()));

          if (!isNaN(coords[0]) && !isNaN(coords[1])) {
            const marker = L.marker(coords, { icon: customIcon });

            const popupContent = `
              <div class="custom-map-popup">
                <div class="popup-flex">
                  <img src="${this.getThumbnail(tenant)}" class="popup-img" />
                  <div class="popup-info">
                    <h4>${tenant.nama_profil.toUpperCase()}</h4>
                    <p class="popup-desc">${tenant.alamat_lengkap}</p>
                  </div>
                </div>
              </div>
            `;

            marker.bindPopup(popupContent, {
              maxWidth: 300,
              className: "clean-leaflet-popup",
            });

            this.markerClusterGroup.addLayer(marker);
            bounds.push(coords);
          }
        }
      });

      this.map.addLayer(this.markerClusterGroup);

      if (bounds.length > 0) {
        this.map.fitBounds(bounds, { padding: [50, 50] });
      }
    },
    selectTenant(tenant) {
      this.activeTenantId = tenant.id;
      this.selectedTenantData = tenant;

      if (tenant.lokasi_map && tenant.lokasi_map.includes(",") && this.map) {
        const coords = tenant.lokasi_map.split(",").map((num) => parseFloat(num.trim()));

        this.map.flyTo(coords, 17, {
          animate: true,
          duration: 1.5,
        });
      }
    },
    goToDetail(id) {
      this.$router.push({ name: "tenant_detail", params: { id } });
    },
    callTenant(phone) {
      if (phone) window.open(`tel:${phone}`);
    },
  },
};
</script>

<style scoped>
.tenant-app {
  background-color: #f3f7f6 !important;
  height: 100vh !important;
  overflow: hidden !important;
}

.main-header {
  border-bottom: 1px solid #eef2f1 !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02) !important;
  z-index: 100;
}

.back-btn {
  background-color: #f1f5f4 !important;
  transition: background-color 0.2s ease, transform 0.2s ease;
}
.back-btn:hover {
  background-color: rgba(1, 140, 116, 0.12) !important;
  transform: translateX(-2px);
}

.main-content-layout {
  height: calc(100vh - 70px) !important;
  overflow: hidden !important;
}
.fill-height-container {
  height: 100% !important;
  max-height: 100% !important;
}
.fill-height-row {
  height: 100% !important;
}
.fill-column {
  height: 100% !important;
  display: flex;
  flex-direction: column;
}

.sidebar-layout-card,
.map-container-card,
.detail-display-card {
  background-color: #ffffff !important;
  border: 1px solid #e8eceb !important;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.02) !important;
}

.sidebar-layout-card {
  height: 100% !important;
  max-height: 100% !important;
  overflow: hidden;
}
.sidebar-scroll-content {
  overflow-y: auto;
}
.sidebar-top-pane {
  background: #ffffff;
}
.sidebar-bottom-pane {
  background: #ffffff;
  border-top: 1px solid #f0f4f3;
}

.tenant-item-card {
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff !important;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease-in-out;
}
.tenant-item-card:hover {
  border-color: #018c74 !important;
  background-color: #f7faf9 !important;
}
.active-item {
  border: 1.5px solid #018c74 !important;
  background-color: #f0f7f5 !important;
}

.row-hover-effect {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, #018c74, #cfa22d);
  opacity: 0;
  transition: opacity 0.2s ease;
  border-radius: 4px 0 0 4px;
}
.tenant-item-card:hover .row-hover-effect,
.active-item .row-hover-effect {
  opacity: 1;
}

.action-route-btn {
  transition: transform 0.2s ease;
}
.action-route-btn:hover {
  transform: scale(1.15);
  background-color: rgba(1, 140, 116, 0.1) !important;
}
.btn-load-more {
  border: 1px solid #e2e8f0 !important;
  font-size: 0.8rem !important;
}

::v-deep .search-field .v-input__control .v-input__slot {
  background-color: #f8fafc !important;
  border-radius: 8px !important;
}

.map-inner-display {
  height: 100%;
  width: 100%;
}

.detail-display-card {
  height: auto;
  min-height: 190px;
}
.detail-preview-img {
  object-fit: cover;
}
.info-paragraph-text {
  line-height: 1.5;
}
.border-top-light {
  border-top: 1px solid #edf2f7;
}

.border-primary {
  border: 1.5px solid rgba(1, 140, 116, 0.2) !important;
}
.bg-light {
  background-color: #f8fafc !important;
}

.primary-text {
  color: #1e293b !important;
}
.text-secondary {
  color: #64748b !important;
}
.text-light-grey {
  color: #94a3b8 !important;
}
.white--text {
  color: #ffffff !important;
}

.map-container-card {
  position: relative;
  z-index: 0;
  isolation: isolate; /* kurung semua z-index Leaflet di dalam card ini */
}

.map-inner-display {
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 0;
}

::v-deep .clean-leaflet-popup .leaflet-popup-content-wrapper {
  background: #ffffff;
  border-radius: 12px;
  padding: 2px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}
::v-deep .clean-leaflet-popup .leaflet-popup-content {
  margin: 6px;
  width: 270px !important;
}
::v-deep .custom-map-popup .popup-flex {
  display: flex;
  align-items: center;
}
::v-deep .custom-map-popup .popup-img {
  width: 65px;
  height: 65px;
  object-fit: cover;
  border-radius: 8px;
  margin-right: 10px;
}
::v-deep .custom-map-popup .popup-info h4 {
  margin: 0 0 2px 0;
  color: #1e293b;
  font-size: 0.85rem;
  font-weight: 700;
}
::v-deep .custom-map-popup .popup-desc {
  margin: 0 0 4px 0;
  font-size: 0.65rem;
  color: #64748b;
  line-height: 1.3;
}

.sidebar-scroll-content::-webkit-scrollbar {
  width: 4px;
}
.sidebar-scroll-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.media-detail-wrapper {
  background-color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 140px;
  max-height: 150px;
}

.detail-preview-video {
  width: 100%;
  height: 100%;
  max-height: 150px;
  object-fit: cover;
}

/* =====================================================
   ANIMASI TOMBOL KONTRIBUSI PUBLIK
   - Gradient hijau -> emas bergerak pelan
   - Pulse ring berkala untuk menarik perhatian
   - Shimmer (kilau) yang menyapu tombol
   - Ikon berputar saat hover, "bernapas" saat idle
   - Efek tekan saat diklik
   ===================================================== */
.btn-kontribusi {
  position: relative;
  overflow: hidden;
  height: 42px !important;
  letter-spacing: 0.2px;
  background: linear-gradient(
    120deg,
    #018c74,
    #02a98c,
    #018c74,
    #cfa22d,
    #018c74
  ) !important;
  background-size: 300% 300% !important;
  animation: kontribusi-gradient 8s ease infinite, kontribusi-pulse 2.4s ease-out infinite;
  transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.25s ease;
  will-change: transform, box-shadow;
}

/* Shimmer / kilau yang menyapu dari kiri ke kanan.
   Memakai ::after karena ::before dipakai Vuetify untuk overlay hover. */
.btn-kontribusi::after {
  content: "";
  position: absolute;
  top: 0;
  left: -75%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    120deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.45) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: skewX(-20deg);
  animation: kontribusi-shimmer 3.2s ease-in-out infinite;
  pointer-events: none;
}

/* Pastikan teks & ikon tetap di atas kilau */
.btn-kontribusi ::v-deep .v-btn__content {
  position: relative;
  z-index: 1;
}

.btn-kontribusi:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.35) !important;
  animation-play-state: running, paused; /* hentikan pulse saat hover */
}
.btn-kontribusi:hover::after {
  animation-duration: 1.1s; /* kilau lebih cepat saat hover */
}

.btn-kontribusi:active {
  transform: translateY(0) scale(0.97);
  box-shadow: 0 2px 8px rgba(1, 140, 116, 0.3) !important;
}

/* Ikon "bernapas" saat idle, berputar & membesar saat hover */
.kontribusi-icon {
  animation: kontribusi-icon-breathe 2.4s ease-in-out infinite;
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.btn-kontribusi:hover .kontribusi-icon {
  animation: none;
  transform: rotate(180deg) scale(1.25);
}

@keyframes kontribusi-gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes kontribusi-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(1, 140, 116, 0.55);
  }
  70% {
    box-shadow: 0 0 0 12px rgba(1, 140, 116, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(1, 140, 116, 0);
  }
}

@keyframes kontribusi-shimmer {
  0% {
    left: -75%;
  }
  60%,
  100% {
    left: 130%;
  }
}

@keyframes kontribusi-icon-breathe {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}

/* Hormati pengguna yang mematikan animasi di perangkatnya */
@media (prefers-reduced-motion: reduce) {
  .btn-kontribusi,
  .btn-kontribusi::after,
  .kontribusi-icon {
    animation: none !important;
  }
}
</style>
